import 'react-app-polyfill/ie9';
import React, { ErrorInfo, Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { notification, message } from 'antd';
import { addClassList } from './global/toolMethod';
import { PageLoading } from './components/PageLoading';
import { Menus } from './router';
import './index.less';

message.config({
    maxCount: 1,
});

export default class App extends React.PureComponent {
    public componentDidCatch(error: Error, info: ErrorInfo) {
        notification.error({
            message: 'something was error',
            description: info.componentStack,
            duration: 5,
        });
    }

    public render() {
        return (
            <BrowserRouter basename='/baike/'>
                <Suspense fallback={<PageLoading />}>
                    <Switch>
                        {Menus.map(menu => (
                            <Route key={menu.title} path={menu.path} component={menu.component} />
                        ))}
                        <Redirect from='*' to='/' />
                    </Switch>
                </Suspense>
            </BrowserRouter>
        );
    }
}

addClassList();

ReactDOM.render(<App />, document.getElementById('root'));
